import React from "react";
import "./style.scss";
import { useSelector } from "react-redux";
import { State } from "../../store";
import { useTranslation } from "react-i18next";

const AccountActivatedDetails: React.FC = () => {
  const saleConfiguration = useSelector((state: State) => state.config.configuration);
  const { t } = useTranslation();

  return (
    <React.Fragment>
      <article className="">{t("od_teraz_mozesz_korzystac_z_kolejnych_odogodnien")}</article>

      <div className="flex-center-center flex-wrap prons">
        <b className="alert alert-small alert-yellow">{t("dostep_do_rachunkow_dokumentow")}</b>
        <b className="alert alert-small alert-yellow">{t("dostep_do_wykupionych_biletow")}</b>
        {saleConfiguration.passSaleActive && (
          <b className="alert alert-small alert-yellow">{t("dostep_do_wykupionych_karnetow")}</b>
        )}
        {saleConfiguration.allowReservationByPassOnFitnessPlan && (
          <b className="alert alert-small alert-yellow">{t("mozliwosc_zapisu_sie_karnetem_na_zajecia")}</b>
        )}

        {saleConfiguration.calendar_AllowPassChange && (
          <b className="alert alert-small alert-yellow">{t("zarzadzenie_wieloma_karnetami")}</b>
        )}
        {saleConfiguration.allowReservedExerciseChange && (
          <b className="alert alert-small alert-yellow">{t("mozliwosc_zmiany_terminu_realizacji_biletow")}</b>
        )}
        {saleConfiguration.ecard_PayByEcard && (
          <b className="alert alert-small alert-yellow">
            {t("mozliwosc_placenia_nasza")} {saleConfiguration.giftCard3Message}
          </b>
        )}
        {saleConfiguration.ecard_RegisterIncome && (
          <b className="alert alert-small alert-yellow">
            {t("mozliwosc_doladowania_naszej")} {saleConfiguration.giftCard1Message}
          </b>
        )}
        {saleConfiguration.newsLetterActive && (
          <b className="alert alert-small alert-yellow">{t("mozliwosc_zapisu_na_newsletter")}</b>
        )}
      </div>
    </React.Fragment>
  );
};

export default AccountActivatedDetails;
